/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, currency: NonNullable<unknown> }} Membership_Plan_Change_Keep_OptionInputs */

const fr_membership_plan_change_keep_option = /** @type {(inputs: Membership_Plan_Change_Keep_OptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conserver l'accès 6h-23h (+${i?.amount} ${i?.currency} / mois)`)
};

/**

* @param {Membership_Plan_Change_Keep_OptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_keep_option = /** @type {((inputs: Membership_Plan_Change_Keep_OptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_Keep_OptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_keep_option(inputs)
});